import { render, staticRenderFns } from "./VPrescriptionHistory.vue?vue&type=template&id=57efd754&"
import script from "./VPrescriptionHistory.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionHistory.vue?vue&type=style&index=0&id=57efd754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports